<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='分类列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加分类</el-button>
        </el-col>
        <el-col v-if="roleId==1" :span="4">
          <el-select v-model="param.admin_id" placeholder="请选择所属者" filterable @change="getList">
            <el-option label="请选择所属者" :value="0"></el-option>
            <el-option v-for="item in adminList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
<!--        <el-col v-if="roleId==1" :span="4">
          <el-select v-model="param.group_id" placeholder="请选择合集" filterable @change="getList">
            <el-option label="请选择合集" :value="0"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col> -->
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column label="名称" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/0/h/50'" class="list_img"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center" width="80px"></el-table-column>
        <el-table-column v-if="roleId==1" prop="admin_name" label="所属" align="center"></el-table-column>
        <el-table-column v-if="roleId==1" prop="group_name" label="合集" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <category-add :visible="addDialogAvaible"
      :id="currentId"
      :groupList="groupList"
      @add="addCategory"
      @update="updateCategory"
      @closeDialog="closeAddDialog"></category-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import CategoryAdd from './CategoryAdd.vue'
export default {
  name: 'category_list',
  components: {
    'bread-crumb': BreadCrumb,
    'category-add': CategoryAdd
  },
  created () {
    this.param.news_index = process.env.VUE_APP_NEWS_INDEX
    this.getList()
    this.getAdminList()
    this.getGroupList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      adminList: [],
      groupList: [],
      addDialogAvaible: false,
      roleId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        admin_id: 0,
        group_id: 0,
        news_index: 1,
        page: 1,
        count: 10
      }
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/category/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
      this.roleId = parseInt(window.sessionStorage.getItem('role_id'))
    },
    async getAdminList () {
      const res = await this.$http.get('/admin/select_list')
      if (res.code === 0) {
        this.adminList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getGroupList () {
      const res = await this.$http.get('/admin/group/select_list')
      if (res.code === 0) {
        this.groupList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async addCategory (data) {
      const res = await this.$http.post('/admin/category/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateCategory (id, data) {
      const res = await this.$http.post('/admin/category/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/category/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
